import { error } from 'jquery';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DriverService } from '../../services/driver/driver.service';
import { appService } from '../../../_services/app.service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../../../helpers';
import * as L from 'leaflet';
// import { subCompanyField } from 'src/app/new-network/model/fromFields/subCompany';
@Component({
  selector: 'app-new-common-locations',
  templateUrl: './new-common-locations.component.html',
  styleUrls: ['./new-common-locations.component.scss']
})
export class NewCommonLocationsComponent implements OnInit, AfterViewInit {
  @Input() data: any = {};
  @Input() LocationId: any;
  @Input() CustomerId: any;
  @Output() onCloseEvent = new EventEmitter<any>();
  @Output() CallGetAPI = new EventEmitter<any>();
  isSearch: boolean = false;
  CompanyId: any;
  TenantId: any;
  UserId: any;
  LocationCompanyId: any;
  isFormSubmit: boolean = false;
  SystemValueForAutoUpdateLatLng: boolean = false;

  Code: any = {
    lable: "Location Code",
    placeholder: "Enter location code",
    dataField: 'Code',
    formControlName: 'Code',
    isRequired: true,
  }
  Name: any = {
    lable: "Location Name",
    placeholder: "Enter location name",
    dataField: 'Name',
    formControlName: 'Name',
    isRequired: true,
  }
  Floor: any = {
    lable: "Floor",
    placeholder: "Enter floor",
    dataField: 'Floor',
    formControlName: 'Floor'
  }
  FlatNo: any = {
    lable: "Flat Number",
    placeholder: "Enter flat number",
    dataField: 'FlatNo',
    formControlName: 'FlatNo',
    type: 'number'
  }
  Address: any = {
    lable: "Address",
    dataField: 'Address',
    formControlName: 'Address',
    placeholder: "Enter Strret/Area",
    isRequired: true,
  }
  Landmark: any = {
    lable: "Landmark",
    dataField: 'LandMark',
    formControlName: 'LandMark',
    placeholder: "Enter landmark"

  }
  PostalCode: any = {
    lable: "User.Pincode",
    dataField: 'PostalCode',
    formControlName: 'PostalCode',
    placeholder: "select pincode",
    isSearch: false,
    isRequired: true,
  };
  Country: any = {
    lable: "Country",
    dataField: 'Country',
    formControlName: 'Country',
    placeholder: "Select country",
    isSearch: false,
    isRequired: true,
  };
  State: any = {
    lable: "State",
    dataField: 'State',
    formControlName: 'State',
    placeholder: "Enter state",
    isSearch: false,
    isRequired: true,
  };
  City: any = {
    lable: "City",
    dataField: 'City',
    formControlName: 'City',
    placeholder: "Select city",
    isSearch: false,
    isRequired: true,
  };
  GSTNo: any = {
    lable: "GST No",
    dataField: 'GSTNo',
    formControlName: 'GSTNo',
    placeholder: "Enter GST No",
  }
  Latitude: any = {
    lable: "Latitude",
    placeholder: "Enter latitude",
    dataField: 'Latitude',
    formControlName: 'Latitude',
    type: 'number'
  }
  Longitude: any = {
    lable: "Longitude",
    placeholder: "Enter longitude",
    dataField: 'Longitude',
    formControlName: 'Longitude',
    type: 'number'
  }
  ContactPerson: any = {
    lable: "Contact Person Name",
    placeholder: "Enter contact person name",
    dataField: 'ContactPerson',
    formControlName: 'ContactPerson',
  }
  MobileNumber: any = {
    lable: 'Mobile Number',
    placeholder: 'Enter contact person number',
    dataField: 'MobileNumber',
    formControlName: 'MobileNumber',
    type: 'number'
  }
  Email: any = {
    lable: "Email Address",
    placeholder: "Enter email address",
    dataField: 'Email',
    formControlName: 'Email',
  }
  SubCompanyField: any = {
    lable: "Sub Company",
    dataField: 'SubCompanyField',
    formControlName: 'SubCompanyField',
    placeholder: "Select Sub Company",
    isSearch: false,
    isRequired: true,
    isMultipleSelect: true,
    isValueBind: true
  };
  Remark: any = {
    lable: "Remarks",
    placeholder: 'Enter remark',
    dataField: 'Remark',
    formControlName: 'Remark',
  }
  @ViewChild('mapLatLong') mapContainerLatLong: ElementRef;
  private mapLatLong: L.Map | null = null;
  RouteNameFeild: any = {
    lable: "Route Name",
    placeholder: "Select Route Name",
    dataField: "RouteName",
    formControlName: "RouteName",
    isRequired: false,
    isSearchByApi: true,
    typeOfField: "dropdown",
    isValueBind: true
  };

  LandMarkFeild: any = {
    lable: "Land Mark",
    placeholder: "Select Land Mark",
    dataField: "LandMark",
    formControlName: "LandMark",
    isRequired: false,
    isSearchByApi: true,
    typeOfField: "dropdown",
    isValueBind: true
  };

  MasterRoute: any = {
    lable: "Master Route",
    placeholder: "Select here",
    dataField: "MasterRoute",
    formControlName: "MasterRoute",
    isRequired: false,
    isSearchByApi: true,
    typeOfField: "dropdown",
    isValueBind: true,
    addTag: true
  };

  constructor(
    private driverService: DriverService,
    private _appService: appService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
  }

  getDropdownList(value, dataField, type) {
    if (dataField == 'SubCompanyField') {
      if (value.length > 0) {
        type.isSearch = true;
        this._appService.GetByFourId("Carrier", "ctp_getSubCompanyList", this.UserId, this.data.CompanyId ? this.data.CompanyId : this.LocationCompanyId, this.data.Id, value).subscribe((response) => {
          this.findObjectOfTheField(dataField, response, type);
        },
          (err) => {
            this.toastr.error("Error occurred while fetching data !", "error");
          }
        );
      }
    }
  }

  findObjectOfTheField(dataField, dropdownList, type) {
    type.dropdownList = dropdownList;
    type.isSearch = false;
    if (type.dataField) {
      type.isReadOnly = false
    }
  }

  GetsystemSettingValueForAutoUpdateLatLng() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "AutoUpdateLatLng")
      .subscribe(
        (response) => {
          if (response == "1") {
            this.SystemValueForAutoUpdateLatLng = true;
          } else {
            this.SystemValueForAutoUpdateLatLng = false;
          }
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
        }
      );
  }

  ngOnChanges(changes: SimpleChanges): void {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;

    if (changes['LocationId'] && changes['LocationId'].currentValue) {
      this.GetNewWarehouseList();
    }

    if (changes['CustomerId'] && changes['CustomerId'].currentValue) {
      this.LocationCompanyId = this.CustomerId;
      console.log('LocationCompanyId', this.LocationCompanyId);
    }
  }

  getChangedValue(value, dataField) {
    if (value === undefined) {
      value = null;
      this.data[dataField] = value;
    } else {
      if (dataField === 'Country' || dataField === 'City' ||
        dataField === 'PostalCode' || dataField === 'State') {
        // this.data[dataField] = value.value;
        this.data[dataField] = (value && value.value) ? value.value : value;
        if (dataField === 'PostalCode') {
          const addressDetails = value
          this.data.City = addressDetails.CityName || null;
          this.data.Country = addressDetails.CountryName || null;
          this.data.State = addressDetails.StateName || null;
        }
      } else if (dataField === 'Floor') {
        this.data[dataField] = value !== null ? parseInt(value, 10) : null;
      } else if (dataField === 'GSTNo') {
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        const trimmedGst = value.trim();
        if (!gstRegex.test(trimmedGst)) {
          this.toastr.warning('Invalid GST number');
          return;
        }
        this.data[dataField] = trimmedGst;
      } else if (dataField === 'Email') {
        const regEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const trimmedemail = value.trim();
        if (!regEx.test(trimmedemail.trim())) {
          this.toastr.warning("Please enter a valid Email address.", "Email");
          return;
        }
        this.data[dataField] = trimmedemail;
      } else if(dataField === 'RouteName' || dataField === 'LandMark'){
        this.data[dataField] = value.value;
      } else if (dataField === 'MasterRoute') { //added by fahim 27-04-2026
        const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
        this.data[dataField] = newValue;
      } else {
        this.data[dataField] = value;
      }
    }
    // this.modifiedValueOutput.emit({ value, dataField });
    // this.readonlyStateChange();
  }

  // readonlyStateChange() {
  //   if (this.data) {
  //     this.State.isReadOnly = this.data[this.Country.dataField] ? false : true;
  //     this.City.isReadOnly = this.data[this.State.dataField] ? false : true;
  //   }
  // }


  getAddressDetails(searchedKey) {
    this.isSearch = true;
    this.driverService.getAdressDetailByPostcode(searchedKey).then((x: any[]) => {
      x = x.slice(0, 50);
      this.PostalCode = { ...this.PostalCode, dropdownList: x };
      this.isSearch = false;
    }).catch((error) => {
      this.isSearch = false;
    })
  }

  getCountryDetails(searchedKey, categoryName, parentId = null, objName) {
    this[objName].isSearch = true;
    this.driverService.getCountryDetailByPostcode(searchedKey, categoryName, parentId).then((x: any[]) => {
      x = x.slice(0, 50);
      this[objName] = { ...this[objName], dropdownList: x };
      this[objName].isSearch = false;
    }).catch((error) => {
      this[objName].isSearch = false;
    })
  }

  onClose() {
    this.onCloseEvent.emit();
  }

  GetNewWarehouseList() {
    this._appService.GetByTwoParam('Carrier', 'GetNewWarehouseList', this.LocationId, this.CompanyId).subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.data = response[0];
          this.data.State = this.data.RegionState;
          this.data.City = this.data.Town;

          this.SubCompanyField.dropdownList = [];
          if (this.data.SubCompanyList != null) {
            this.findObjectOfTheField(this.SubCompanyField.dataField, JSON.parse(this.data.SubCompanyList), this.SubCompanyField);
            // this.SubCompanyField.dropdownList = JSON.parse(this.data.SubCompanyList);
            // console.log('this.SubCompanyField.dropdownList', this.SubCompanyField.dropdownList);
          }
          this.data[this.SubCompanyField.dataField] = [];
          for (const item of this.SubCompanyField.dropdownList) {
            var obj: any = {};
            obj = item.value;
            this.data[this.SubCompanyField.dataField].push(obj);
          }

          this.SetDropdown(this.RouteNameFeild, this.data.RouteName, this.data.RouteName);
          this.SetDropdown(this.LandMarkFeild, this.data.LandMark, this.data.LandMark);
          this.SetDropdown(this.MasterRoute, this.data.MasterRoute, this.data.MasterRoute);

          console.log('this.data[this.SubCompanyField.dataField]', this.data[this.SubCompanyField.dataField]);
          console.log('this.SubCompanyField.dropdownList', this.SubCompanyField.dropdownList);
        } else {
          this.data = {};
        }
      },
      (error) => {
        this.toastr.error('Error while getting Locations list', 'Error');
      }
    )
  }

  onSaveBtnClick() {
    this.data.RegionState = this.data.State;
    this.data.Town = this.data.City;
    // this.data.SubCompany = this.data.SubCompanyField.join(',');
    //added by fahim 08-01-2026 :)
    if (this.data.SubCompanyField && this.data.SubCompanyField.length > 0) {
      this.data.SubCompany = this.data.SubCompanyField.join(',');
    } else {
      this.data.SubCompany = null;
    }
    //end added by fahim 08-01-2026 :)
    console.log('this.data[this.SubCompanyField.dataField]', this.data[this.SubCompanyField.dataField]);
    console.log('this.data.SubCompanyField', this.data.SubCompanyField);
    console.log('this.SubCompanyField', this.SubCompanyField);
    this.data.CompanyId = this.data.CompanyId ? this.data.CompanyId : this.LocationCompanyId;
    Helpers.setLoading(true);
    this.isFormSubmit = true;
    if (this.Validate()) {
      this._appService.Post('Carrier', 'SaveCarrierData', this.data).subscribe(
        (response) => {
          this.LocationId = this.LocationId ? this.LocationId : response;
          this.GetNewWarehouseList();
          this.toastr.success('Data saved successfully!', 'success');
          Helpers.setLoading(false);
          this.CallGetAPI.emit(true);
          this.onCloseEvent.emit();
        },
     (error) => {
    this.toastr.warning(error._body,
        'warning'
    ); //add by pawan 12-08-2026

    Helpers.setLoading(false);
}
      );
    } else {
      Helpers.setLoading(false);
      // this.isSaving = false; 
    }
  }

  Validate() {
    var IsAllDataDone: any = true;
    if (!this.data.Code) {
      IsAllDataDone = false;
    }
    if (!this.data.Name) {
      IsAllDataDone = false;
    }
    if (!this.data.Address) {
      IsAllDataDone = false;
    }
    if (!this.data.PostalCode) {
      IsAllDataDone = false;
    }
    if (!this.data.Country) {
      IsAllDataDone = false;
    }
    if (!this.data.State) {
      IsAllDataDone = false;
    }
    if (!this.data.City) {
      IsAllDataDone = false;
    }

    if (!IsAllDataDone) {
      this.toastr.warning('Please Enter the Required Field !', "warning");
    }
    return IsAllDataDone;
  }

  ngAfterViewInit(): void {
    this.GetsystemSettingValueForAutoUpdateLatLng();
    // this.InitMapLeaflet();
  }

  InitMapLeaflet() {
    const containerEl = this.mapContainerLatLong.nativeElement;
    var initialCoords = null;
    if (this.data.Latitude == null || this.data.Longtitude == null) {
      initialCoords = [18.9836681, 73.0525676] as L.LatLngExpression;
    } else {
      initialCoords = [this.data.Latitude, this.data.Longtitude] as L.LatLngExpression;
    }

    if (this.mapLatLong) {
      this.mapLatLong.remove();
    }

    this.mapLatLong = L.map(containerEl).setView(initialCoords, 7);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapLatLong);

    setTimeout(() => this.mapLatLong.invalidateSize(), 200);
    setTimeout(() => this.mapLatLong.invalidateSize(), 1000);

    // this.showOrigin(address);
  }

  getRouteNameDropdown(value, dataField, type) {
    if (value.length > 0) {
      type.isSearch = true;
      this._appService.GetByThreeId("Carrier", "ctp_GetRouteNameList", this.UserId, this.CompanyId, value).subscribe(
        (response) => {
          this.findObjectOfTheField(dataField, response, type);
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
        }
      );
    }
  }

  getLandMarkDropdown(value, dataField, type) {
    if (value.length > 0) {
      type.isSearch = true;
      this._appService.GetByThreeId("Carrier", "ctp_GetLandmarkList", this.UserId, this.CompanyId, value).subscribe(
        (response) => {
          this.findObjectOfTheField(dataField, response, type);
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
        }
      );
    }
  }

  SetDropdown(field: any, value: any, name: any) {
    if (value === null || value === undefined || value === '') {
      field.dropdownList = [];
      return;
    }
    field.dropdownList = [
      {
        value: value,
        name: name
      }
    ];
  }

  getMasterRouteDropdown(value, isScrollDown = false) {
    this.MasterRoute.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.MasterRoute.dropdownList.length / 20) + 1;
    }

    this._appService.GetByThreeId("Carrier", "GetMasterRouteList", this.UserId, this.CompanyId, value).subscribe(
      (res) => {
        let response = res || []; 
        let dropdownList = [...response];
        
        if (
          isScrollDown &&
          response &&
          response.Total &&
          response.Total > this.MasterRoute.dropdownList.length
        ){
          dropdownList = dropdownList.concat(this.MasterRoute.dropdownList);
          this.MasterRoute = { ...this.MasterRoute, dropdownList: [...dropdownList] };
        }
        if (!isScrollDown) {
          this.MasterRoute = { ...this.MasterRoute, dropdownList: [...dropdownList] };
        }
        this.MasterRoute.isSearch = false;
      },
      (err) => {
        this.MasterRoute.isSearch = false;
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

}
